/**
 * Monster Cart Pack Filter
 * Disables the "One of each" Type option in the Monster Cart sticky bar
 * when 1-Pack is active. Uses CSS injection + capture-phase click blocking
 * so React re-renders cannot undo the effect.
 */
(function () {
  'use strict';

  var ONE_PACK    = '1-Pack';
  var MIXED_LABEL = 'One of each';
  var STICKY_ID   = 'monster-upsell-sticky-cart';
  var DATA_ATTR   = 'data-pack-filter';
  var STYLE_ID    = 'mu-pack-filter-styles';

  /* ------------------------------------------------------------------
     1. Inject a <style> tag once — CSS beats React inline re-renders
     ------------------------------------------------------------------ */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#' + STICKY_ID + '[' + DATA_ATTR + '="' + ONE_PACK + '"] ' +
      'li[data-display="' + MIXED_LABEL + '"] {' +
      '  opacity: 0.35 !important;' +
      '  pointer-events: none !important;' +
      '  cursor: not-allowed !important;' +
      '}';
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------------
     2. Capture-phase click block — fires before React's handlers
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var li = e.target.closest('li[data-display="' + MIXED_LABEL + '"]');
    if (!li) return;
    var stickyCart = document.getElementById(STICKY_ID);
    if (!stickyCart || !stickyCart.contains(li)) return;
    if (stickyCart.getAttribute(DATA_ATTR) === ONE_PACK) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true); // capture = true → runs before any React onClick

  /* ------------------------------------------------------------------
     3. Apply / remove filter by setting a data attribute on the container
        React owns its children but not attributes we set on the root div
     ------------------------------------------------------------------ */
  function applyFilter(packValue) {
    var stickyCart = document.getElementById(STICKY_ID);
    if (!stickyCart) return;

    stickyCart.setAttribute(DATA_ATTR, packValue);

    // If "One of each" is currently selected and we're switching to 1-Pack,
    // auto-click the first valid type option to clear the selection
    if (packValue === ONE_PACK) {
      var mixedLi = stickyCart.querySelector('li[data-display="' + MIXED_LABEL + '"]');
      if (mixedLi && mixedLi.className.indexOf('selected') !== -1) {
        var siblings = mixedLi.parentElement
          ? mixedLi.parentElement.querySelectorAll('li[data-display]')
          : [];
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i].getAttribute('data-display') !== MIXED_LABEL) {
            siblings[i].click();
            break;
          }
        }
      }
    }
  }

  /* ------------------------------------------------------------------
     4. Read the current pack value from the page
     ------------------------------------------------------------------ */
  function getCurrentPack() {
    // Checked bundle-picker pill on the product form
    var pill = document.querySelector('input[name="bundle-pack"]:checked');
    if (pill) return pill.value;

    // Selected Pack option inside the sticky cart itself
    var stickyCart = document.getElementById(STICKY_ID);
    if (stickyCart) {
      var selected = stickyCart.querySelector(
        'li[data-display*="-Pack"][class*="selected"]'
      );
      if (selected) return selected.getAttribute('data-display');
    }

    // Bundle-picker JSON fallback
    var json = document.querySelector(
      'bundle-picker script[type="application/json"]'
    );
    if (json) {
      try {
        var variants = JSON.parse(json.textContent);
        if (variants && variants.length) return variants[0].option1;
      } catch (e) {}
    }
    return null;
  }

  /* ------------------------------------------------------------------
     5. Subscribe to variant changes and sticky-cart Pack clicks
     ------------------------------------------------------------------ */
  // Remember the last known pack so re-renders don't reset it
  var activePack  = null;
  var subscribed  = false;

  function setup() {
    injectStyles();

    // Only read from the page on first run
    if (!activePack) {
      activePack = getCurrentPack();
    }
    if (activePack) applyFilter(activePack);

    if (!subscribed &&
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.option1) {
          activePack = variant.option1;
          applyFilter(activePack);
        }
      });
      subscribed = true;
    }

    // Re-bind click listener (element may be a new node after re-render)
    var stickyCart = document.getElementById(STICKY_ID);
    if (stickyCart && !stickyCart._packFilterBound) {
      stickyCart._packFilterBound = true;
      stickyCart.addEventListener('click', function (e) {
        var li = e.target.closest('li[data-display]');
        if (!li) return;
        var val = li.getAttribute('data-display');
        if (val && val.indexOf('-Pack') !== -1) {
          setTimeout(function () {
            activePack = val;
            applyFilter(val);
          }, 50);
        }
      });
    }
  }

  function trySetup() {
    if (document.getElementById(STICKY_ID)) setup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(trySetup, 400);
    });
  } else {
    setTimeout(trySetup, 400);
  }

  // Re-apply using remembered pack value — never re-read from page
  new MutationObserver(function () {
    if (document.getElementById(STICKY_ID)) {
      if (activePack) applyFilter(activePack);
      // Re-bind listener if Monster Cart replaced the element
      var stickyCart = document.getElementById(STICKY_ID);
      if (stickyCart && !stickyCart._packFilterBound) setup();
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
